"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _ModalSelectFoto = _interopRequireDefault(require("../ModalSelectFoto"));

var _uploadBro = _interopRequireDefault(require("../../images/upload-bro.svg"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormFotoPrincipal extends _react.default.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.guardar = this.guardar.bind(this);
    this.state = {
      open: false,
      fotos: this.props.fotos
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fotos != this.props.fotos) {
      this.setState({
        fotos: this.props.fotos
      });
    }
  }

  openModal(value) {
    this.setState({
      open: value
    });
  }

  guardar(foto) {
    this.openModal(false);
    this.props.onChange(foto);
  }

  render() {
    const {
      titulo,
      explicacion,
      fotoSelected
    } = this.props;
    const {
      open
    } = this.state;
    return (0, _react2.jsx)("div", {
      css: _style.default.root
    }, (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, titulo)), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "body1"
    }, explicacion))), fotoSelected ? (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      css: _style.default.imgWrap
    }, (0, _react2.jsx)("img", {
      css: _style.default.image,
      src: fotoSelected.url
    }))) : (0, _react2.jsx)("div", {
      css: _style.default.emptyStateContainer
    }, (0, _react2.jsx)("img", {
      src: _uploadBro.default,
      css: _style.default.emptyState
    })), (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      css: _style.default.containerAgregarFotos
    }, (0, _react2.jsx)(_material.Button, {
      onClick: () => this.openModal(true),
      variant: "outlined",
      color: "primary"
    }, "Cambiar Foto Principal"))), (0, _react2.jsx)(_ModalSelectFoto.default, {
      titulo: "Seleccionar Principal",
      classes: _style.default,
      open: open,
      openModal: this.openModal,
      guardar: this.guardar,
      fotos: this.state.fotos,
      fotoSelected: fotoSelected
    }), (0, _react2.jsx)("hr", null));
  }

}

var _default = FormFotoPrincipal;
exports.default = _default;